import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FileLock2, Loader2, LogIn } from "lucide-react";
import { Button } from "../ui/button";
import { useAuth } from "../../context/AuthContext";
import { SecureFileSender } from "./SecureFileSender";
import { SecureFileResult } from "./SecureFileResult";
import { SecureFilesList } from "./SecureFilesList";

// /fichiers : envoi d'UN fichier chiffré dans le navigateur + « Mes fichiers sécurisés » (émetteur connecté).
export default function SecureFilesPage() {
  const { t } = useTranslation("files");
  const { user, loading, activeWorkspaceId } = useAuth();
  const [result, setResult] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  if (loading) return <div className="py-20 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>;
  if (!user) {
    return (
      <div data-testid="sf-login-required" className="max-w-md mx-auto px-4 py-20 text-center space-y-4">
        <FileLock2 className="w-10 h-10 text-emerald-600 mx-auto" />
        <p className="text-slate-700">{t("sender.loginRequired")}</p>
        <Link to="/connexion"><Button data-testid="sf-login-btn" className="bg-emerald-500 hover:bg-emerald-400 text-emerald-950 font-semibold"><LogIn className="w-4 h-4 mr-2" />{t("sender.login")}</Button></Link>
      </div>
    );
  }
  return (
    <div data-testid="secure-files-page" className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
      <div className="mb-8 max-w-2xl">
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900 flex items-center gap-3">
          <FileLock2 className="w-8 h-8 text-emerald-600 shrink-0" />{t("sender.title")}
        </h1>
        <p data-testid="sf-zk-statement" className="mt-3 text-sm sm:text-base text-slate-600 leading-relaxed">{t("sender.subtitle")}</p>
      </div>
      <div className="grid lg:grid-cols-12 gap-6 lg:gap-8 items-start">
        <section className="lg:col-span-7 glass rounded-2xl p-5 sm:p-6">
          {result
            ? <SecureFileResult result={result} onReset={() => setResult(null)} />
            : <SecureFileSender key={activeWorkspaceId} onCreated={(r) => { setResult(r); setRefreshKey((k) => k + 1); }} />}
        </section>
        <aside className="lg:col-span-5">
          <SecureFilesList key={activeWorkspaceId} refreshKey={refreshKey} />
        </aside>
      </div>
    </div>
  );
}
